import React from "react";
import "./StatsSection.css";

export default function StatsSection() {
  const stats = [
    { label: "Years Experience", value: "50+" },
    { label: "Diamonds Crafted", value: "30K+" },
    { label: "Countries Served", value: "65+" },
    { label: "Client Satisfaction", value: "100%" },
  ];

  return (
    <section className="stats1-section">
      <div className="stats1-container">
        <div className="stats1-grid">
          {stats.map((stat, index) => (
            <div
              className="stat1-item fade-up"
              key={stat.label}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="stat1-number">
                <h3 style={{fontWeight: "bold"}}>{stat.value}</h3>
              </div>
              <div className="stat1-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
